/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import Image from "Components/image-with-fallback";
import Link from "next/link";

const Desktop = ({
	attr, name, type, options,
}) => {

	const isSoldOut = attr?.is_in_stock === 0;

	return (
		<div className="cart-item-desktop">
			<div style={{ width: "100%" }}>
				<div style={{ opacity: isSoldOut ? "0.5" : "1" }} className="product-info">
					<Link href={`/detail/${attr.slug}?type=${type}`} passHref>
						{/* this href will be replaced because passHref props see:
						https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/anchor-is-valid.md#case-i-use-nextjs-and-im-getting-this-error-inside-of-links
						*/}
						<a href="replace" className="product-image">
							<Image src={attr.image_url} alt="" />
						</a>
					</Link>
					<div>
						{isSoldOut && (
							<span className="out-of-stock">
								Out of Stock
							</span>
						)}
						<Link href={`/brands/${attr.brand_slug}`}>
							<a href="replace" className="brand">
								{attr.brand_name}
							</a>
						</Link>
						<Link href={`/detail/${attr.slug}?type=${type}`}>
							<a href="replace" className="name">
								{name}
							</a>
						</Link>
						{
							options?.map((item, index) => {

								const option = `${item?.extension_attributes?.value ?? ""}`;
								return (
									<div className="option-item" key={`desktop-${option}-${String(index)}`}>{option}</div>
								);

							})
						}
					</div>
				</div>
			</div>
			<style jsx>
				{`
				.cart-item-desktop {
					display: flex;
					width: 100%;
					box-sizing: border-box;
				}
				.product-info {
					display: flex;
				}
				.product-info .product-image {
					position: relative;
					min-width: 62px;
					min-height: 62px;
					margin-right: 20px;
					cursor: pointer;
				}
				.product-info div {
					display: flex;
					flex-direction: column;
				}
				.name {
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 12px;
					letter-spacing: 0em;
					margin-bottom: 4px;
					text-decoration: none;
					color: #000000;
				}
				a.brand {
					font-size: 12px;
					line-height: 16px;
					letter-spacing: 0em;
					font-weight: 700;
					margin-bottom: 6px;
					text-decoration: none;
					color: #000000;
				}
				
				div.product-info span.out-of-stock {
					
					font-size: 12px;
					font-weight: 400;
					line-height: 16px;
					letter-spacing: 0.04em;
					color: #FF4D4F;
					margin-bottom: 8px;

				}
				.option-item {
					
					font-size: 12px;
					font-weight: 400;
					line-height: 16px;
					letter-spacing: 0.04em;
					text-align: left;
					color: #637381;

				}
			`}
			</style>
		</div>
	);

};

Desktop.propTypes = {
	attr: PropTypes.any.isRequired,
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	options: PropTypes.any,
};

export default Desktop;
